<ng-container *ngIf="!type || type==1">
  <div *ngIf="field.dataTypeId ==5  || field.dataTypeId ==6 || field.dataTypeId ==18"
    style="visibility: hidden;font-size: 10px;">
    Label
  </div>
  <div class="text-right px-0 py-1 position" style="white-space: nowrap;"
    [ngClass]="{'mr-2 status-section':is_section,'status-extra':(!is_section && (field.dataTypeId !=-1  && field.dataTypeId !=13 && field.dataTypeId !=16 && field.dataTypeId !=17  && field.dataTypeId !=20&& field.dataTypeId !=23))}">
    <div class="status__wrapper-extra mx-1 status-section" *ngIf="field.toolTip">
      <i [class]="'fa fa-info-circle tooltip1 mr-1'" [ngbTooltip]=" field.toolTip" container="body"></i>
    </div>
    <div class="status__wrapper-extra mx-1 status-section" *ngFor="let item of verification_status_list"
      [ngClass]="item.id== this.verificationObj[this.field.fieldID]?'active-btn':'d-none'" [matTooltip]="item.title"
      [style]="item.id== this.verificationObj[this.field.fieldID] ? (('--bg-wrapper:rgb(196, 206, 209);--background-wrapper:' + item.colorCode) | SanitizePipe :'style'):(('--background-wrapper:rgb(196, 206, 209);--bg-wrapper:' + item.colorCode) | SanitizePipe :'style')">
      <ng-container *ngIf="item.id== this.verificationObj[this.field.fieldID]">
        <i [class]="'fa ' +item.icon"></i>
      </ng-container>

    </div>

    <div class="status__wrapper-extra mx-1 status-section" *ngIf="field.enableNotes && field.notesType">
      <tm-chats [view_type]="3" [heading]=" ('CLIENT.notesFor' |translate)+ ' ' +(field.label)" [type]="field.notesType"
        [refId]="alertId" [maxLength]="1000" placeholder="{{ 'Enter notes' | translate }}" [label]="'Notes' |translate">
      </tm-chats>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type==2">
  <div [class]="'px-0 py-1 position float-right ' +(control_class?control_class:'')" style="white-space: nowrap;"
    [ngClass]="{'mr-2':is_section}">
    <div class="status__wrapper-extra mx-1 status-section" *ngIf="field.toolTip">
      <i [class]="'fa fa-info-circle tooltip1 mr-1'" [ngbTooltip]=" field.toolTip" container="body"></i>
    </div>
    <div class="status__wrapper-extra mx-1" *ngFor="let item of verification_status_list"
      [ngClass]="item.id== field.verificationStatus?'active-btn':'d-none'" [matTooltip]="item.title"
      [style]="item.id== field.verificationStatus ? (('--bg-wrapper:rgb(196, 206, 209);--background-wrapper:' + item.colorCode) | SanitizePipe :'style'):(('--background-wrapper:rgb(196, 206, 209);--bg-wrapper:' + item.colorCode) | SanitizePipe :'style')">
      <ng-container *ngIf="(item.id == field.verificationStatus)">
        <i [class]="'fa ' +item.icon"></i>
      </ng-container>

    </div>

    <div class="status__wrapper-extra mx-1" *ngIf="field.enableNotes && field.notesType">
      <tm-chats [view_type]="3" [heading]=" ('CLIENT.notesFor' |translate)+ ' ' +(field.label)" [type]="field.notesType"
        [refId]="alertId" [maxLength]="1000" placeholder="{{ 'Enter notes' | translate }}" [label]="'Notes' |translate">
      </tm-chats>
    </div>
  </div>
</ng-container>



<!-- <div class="text-right mb-1">
  <div class="btn-group btn-group-sm" role="group">
    <button type="button" class="btn btn-secondary bg" *ngFor="let item of verification_status_list" (click)="statusChanged(item.id,1)"
      [ngClass]="item.id== this.verificationObj[this.field.fieldID]?'active-btn':''" [matTooltip]="item.title"
      [style]="item.id== this.verificationObj[this.field.fieldID] ? (('--background:' + item.colorCode) | TMsafeHTML :'style'):'--background: white;'">
      <i [class]="'fa ' +item.icon"></i>
    </button>
  </div>
</div> -->